import { IconCamera } from '@tabler/icons-react';
import { Badge } from '@/components/ui/badge';

export function PhotoCountBadge({ count }: { count: number }) {
  return (
    <Badge className='gap-0.75 border-transparent bg-black/55 px-1.75 py-0.75 text-white shadow-[0_1px_3px_rgba(0,0,0,0.3)]'>
      <IconCamera size={13} stroke={2} className='shrink-0' />
      <span className='text-[12px] font-medium leading-none tabular-nums'>{count}</span>
    </Badge>
  );
}
